import React from 'react';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
// const clientId = "130684348959-iii8131d33a8p9i4cotpgtb4l282ckq6.apps.googleusercontent.com"

const GoogleLoginButton = () => {
    const navigate = useNavigate(); // Hook to programmatically navigate



    const handleSuccess = (response) => {
        console.log("Login Success:", response);
        navigate("/home"); // Navigate to the home page after successful login
    };

    const handleError = () => {
        console.error("Login Failed");
    };

    return (
        <div style={{ backgroundColor: "#202020", }}>
            <GoogleLogin
                // clientId={clientId}
                onSuccess={handleSuccess}
                onError={handleError}
                render={(renderProps) => (
                    <button
                        onClick={renderProps.onClick}
                        disabled={renderProps.disabled}
                        style={{
                            background: "transparent",
                            border: "1px solid #ccc",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            // backgroundColor: "#202020",
                            fontSize: "16px",
                            color: "#000",
                            cursor: "pointer",
                        }}
                    >
                        Continue with Google
                    </button>
                )}

            />
        </div>
    );
};

export default GoogleLoginButton;
